<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center">
    <h2 class="page-heading mr-auto">
      <back-button to="/machines"/>
      Общее
      <status-images :value="machine.status" class="ml-3"
        style="display: inline-block; vertical-align: middle; margin-top: -15px; margin-bottom: -15px;"/>
    </h2>
      <button class="btn btn-sm btn-outline-primary" @click="openModal" v-if="$root.checkPermission('web_ta_main_edit')">Редактировать</button>
    </div>

    <div class="row">
      <div class="col-lg col-sm-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="row">
              <div class="field-show col-lg-2 col-sm-6">
                <label>Номер</label>
                {{ machine.serial_number + ' (' + machine.number + ')'}}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Тип</label>
                {{ machine | get('model.type.name', '-') }}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Производитель</label>
                {{ machine | get('creator.name', '-') }}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Модель</label>
                {{ machine | get('model.name', '-') }}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Передача чеков</label>
                {{ machine.receipt_group ? 'Да' : 'Нет' }}
              </div>
              <div class="field-show col-lg-1 col-sm-6">
                <label>Группа ККТ</label>
                {{ machine | get('receipt_group', '-') }}
              </div>
              <div class="field-show col-lg-1 col-sm-6">
                <label>QR-код</label>
                {{ machine.qr ? 'Да' : 'Нет' }}
              </div>
              <div class="w-100"></div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Тип места установки</label>
                {{ machine | get('location_type.name', '-') }}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Дата ввода в эксплуатацию</label>
                {{ machine.start_time | formatDate('DD.MM.YYYY') }}
              </div>
              <div class="field-show col-lg-2 col-sm-6">
                <label>Организация</label>
                {{ machine | get('division.name', '-')}}
              </div>
              <div class="field-show col-lg-4">
                <label>Адрес</label>
                {{ machine.address }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg">
            <div class="card mb-4">
              <div class="card-body">
                <div class="row">
                  <router-link
                    :to="$root.checkPermission('web_downtime') ? '/reports/downtime' + filterQuery : ''"
                    :tag="$root.checkPermission('web_downtime') ? 'a' : 'div'"
                    :class="{'field-show-link': $root.checkPermission('web_downtime')}"
                    class="field-show col-md-4"
                  >
                    <label>
                      <span>Простой без продаж</span>
                      <font-awesome-icon
                        icon="angle-right"
                        class="field-show-link-icon"
                        v-if="$root.checkPermission('web_downtime')"
                      />
                    </label>
                    <date-from-now :date="machine.downtimes_since.sales" :no-suffix="true"/>
                  </router-link>
                  <div class="field-show col-md-4">
                    <label>Простой без купюр</label>
                    <date-from-now :date="machine.downtimes_since.banknotes" :no-suffix="true"/>
                  </div>
                  <div class="field-show col-md-4">
                    <label>Простой без монет</label>
                    <date-from-now :date="machine.downtimes_since.coins" :no-suffix="true"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-5 mb-4">
            <div class="row h-100">
              <div class="col-6">
                <div class="card h-100">
                  <div class="card-body">
                    <div class="field-show">
                      <label>Температура</label>
                      <span v-if="machine.modem">
                          <span v-if="machine.modem.temperature !== null">{{machine.modem.temperature}}&deg;C</span>
                          <span v-else>–</span>
                        </span>
                      <span v-else>модем не подключен</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card h-100">
                  <div class="card-body">
                    <div class="field-show">
                      <label>Магнитные карты</label>
                      <span>{{ machine.cards || 'нет' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="col-lg-3 col-sm-12" style="min-width: 20em;">
        <div v-if="machine.modem">
          <div class="alert" :class="machine.is_online? 'alert-success' : 'alert-danger'">
            <strong>Связь:</strong> {{ machine.is_online ? 'есть' : 'нет' }}
            <strong class="ml-3">Тип:</strong> {{ machine.modem.netinterface }}
            <br>
            <strong>Пинг:</strong> {{ machine.last_ping_at | formatDate }}
          </div>
          <div :class="'alert ' + (machine.modem.battery === 0 ? 'alert-danger' : 'alert-success')">
            <strong>Заряд батареи:</strong>
            <span v-if="machine.modem.battery !== null">{{ machine.modem.battery }} %</span>
            <span v-else>–</span>
          </div>
          <!--<div class="alert" :class="machine.modem.reed ? 'alert-success' : 'alert-danger'">
            <strong>Геркон</strong> {{ machine.modem.reed ? 'сомкнут' : 'разомкнут' }}
          </div>-->
          <div v-if="machine.modem.made_in === 'russia'" class="alert" :class="machine.modem.case ? 'alert-success' : 'alert-danger'">
            <strong>Корпус модема</strong> {{ machine.modem.case ? 'закрыт' : 'открыт' }}
          </div>
          <div class="alert alert-danger" v-if="!machine.modem.electricity">
            <strong>Ошибка питания 220В</strong>
          </div>
        </div>
        <div class='alert alert-danger' v-else> модем не подключен</div>
        <div v-if="machine.special_events.shake"
          class="alert alert-danger alert-dismissible">
          <btn-action @click="() => close(machine.special_events.shake)" class="close"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </btn-action>
          <strong>Автомат трясли</strong>
          <br>
          <strong>{{machine.special_events.shake.date | formatDate}}</strong>
        </div>
        <div v-if="machine.special_events.temperature"
          class="alert alert-danger alert-dismissible">
          <btn-action @click="() => close(machine.special_events.temperature)" class="close"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </btn-action>
          <strong>Отклонение от норм температуры</strong>
          <br>
          <strong>{{machine.special_events.temperature.date | formatDate}}</strong>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-9 col-sm mb-4">
        <div class="card">
          <div class="card-header d-flex align-items-center mb-3">
            <h3 class="my-0 mr-auto"><span class="text-caps">График продаж</span></h3>
            <div class="btn-group btn-group-sm" role="group">
              <button
                class="btn btn-light"
                :class="{'active': showGraph==='hour'}"
                @click="showGraph='hour'"
              >24 часа</button>
              <button
                class="btn btn-light"
                :class="{'active': showGraph==='week'}"
                @click="showGraph='week'"
              >7 дней</button>
              <button
                class="btn btn-light"
                :class="{'active': showGraph==='month'}"
                @click="showGraph='month'"
              >30 дней</button>
            </div>
          </div>
          <div class="card-body">
            <div class="machine show-graphs">
              <graph v-if="showGraph" :endpoint="`machines/${this.id}/sales`" :period="showGraph"/>
            </div>
            <div v-if="$root.checkPermission('web_sales')">
              <router-link :to="'/reports/sales' + filterQuery">Подробнее…</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-12 mb-4">
        <div class="card h-100 d-flex">
          <h3 class="card-header d-flex align-items-center">
            <span class="text-caps">События</span>
            <button v-if="canDsl" :disabled="!machine.modem" class="btn btn-sm btn-outline-primary ml-auto" @click="openVirtCreditModal">Начислить кредит</button>
            <button v-if="canDsl" :disabled="!machine.modem" class="btn btn-sm btn-outline-primary ml-2" @click="openDslModal">Выдача продукта</button>
          </h3>
          <div class="flex-grow-1 position-relative" style="min-height: 220px;">
            <div class="h-100 w-100" style="position: absolute; overflow-y: auto; max-height: 100%;">
              <div class="card-body">
                <table class="w-100 table-sm px-0">
                  <tr v-for="event in machine.last_events">
                    <td class="border-bottom">
                      <strong>{{event.message}}</strong>
                      <a
                        v-if="event.code === 'media'"
                        class="text-monospace text-muted"
                        :href="'/api/admin/commands/' + event.modem_command_id + '/download'"
                      >Скачать</a>
                    </td>
                    <td width="100" class="border-bottom text-right" valign="top">
                      <small><date-from-now :date="event.date" :no-suffix="true"/></small>
                    </td>
                  </tr>
                </table>
                <div  v-if="$root.checkPermission('web_events')">
                  <router-link :to="'/reports/events' + filterQuery">Подробнее…</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="$root.checkPermission('web_service')">
      <div class="col-12">
        <div class="card mb-4" v-if="services">
          <h3 class="card-header"><span class="text-caps">Обслуживание</span></h3>
          <div class="card-body">
            <machine-service-timeline :operator="machine.operator" :tech="machine.technician"
              :planned_prop="services.services_planned"
              :performed_prop="services.services_performed"
              :machine_id="machine.id"
              :region_id="machine.region_id">
            </machine-service-timeline>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-9 col-sm-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="row">
              <div class="field-show col-lg-3 col-sm-6">
                <label>Оператор автомата</label>
                {{ machine.operator | fullName }}
              </div>
              <div class="field-show col-lg-3 col-sm-6">
                <label>Техник автомата</label>
                {{ machine.technician | fullName }}
              </div>
              <div class="field-show col-lg-3 col-sm-6">
                <label>Ответственный менеджер</label>
                {{ machine.manager | fullName }}
              </div>
              <div class="field-show col-lg-3 col-sm-6">
                <label>Арендодатель</label>
                {{ machine.lessor | fullName }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import api from '@/api'
  import { encode } from '@/query-encoder'
  import BtnAction from '../../../components/btn-action'
  import machineModal from '../../../components/machines/modals/machine-modal.vue'
  import dslModal from '../../../components/machines/modals/dsl-modal.vue'
  import virtCreditModal from '../../../components/machines/modals/cashless-modal.vue'

  export default {
    components: {BtnAction},
    props: {
      id: {
        required: true,
      },
      machine: {
        type: Object,
      },
    },
    data () {
      return {
        moment,
        showGraph: 'week',
      }
    },
    methods: {
      close (event) {
        return api.put('events/' + event.id, {
          approved: true,
        }).then((data) => {
          this.machine.special_events[event.code] = data.data
        })
      },
      openModal () {
        this.$root.showModal(machineModal, {
          machine: this.machine,
        }).then((data) => {
          if (data) {
            this.$emit('update:machine', Object.assign(this.machine, data))
          }
        })
      },
      openDslModal () {
        this.$root.showModal(dslModal, {
          matrix: this.machine.matrix,
          isCoffee: this.machine.model ? this.machine.model.type.name !== 'Снековый' : false,
          modemUid: this.machine.modem.uid,
        })
      },
      openVirtCreditModal () {
        this.$root.showModal(virtCreditModal, {
          matrix: this.machine.matrix,
          isCoffee: this.machine.model ? this.machine.model.type.name !== 'Снековый' : false,
          modemUid: this.machine.modem.uid,
        })
      },
    },
    computed: {
      filterQuery () {
        return `?filters=${encode({
          serial_number: [{
            label: this.machine.serial_number,
            value: this.machine.serial_number,
          }],
        })}`
      },
      canDsl () {
        return ['admin', 'branch_admin', 'tech_superior', 'service_superior', 'test_admin']
          .includes(this.$root.user.role.name)
      },
    },
    asyncComputed: {
      services () {
        return api
          .get('services/last/' + this.id)
          .then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .field-show {
    margin: map-get($spacers, 2) 0;
    font-weight: $font-weight-bold;
    > label {
      display: block;
      margin-bottom: .2rem;
      font-weight: normal;
      text-transform: uppercase;
      font-size: 80%;
      letter-spacing: 0.05em;
    }
  }
  .field-show-link {
    color: inherit;
    text-decoration: none !important;
    cursor: pointer;
    > label {
      cursor: pointer;
      > span {
        border-bottom: 1px solid rgba($body-color, .15);
      }
      .field-show-link-icon {
        opacity: .5;
      }
    }
    &:hover {
      > label {
        > span {
          border-bottom: 1px solid rgba($link-hover-color, .35);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/index.vue